import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { Spinner } from 'react-bootstrap';
import { listTypes, urls, menuTypes, formModes, menuTabKeys, resources, backgroundTypes } from '../../constants.js';
import DocumentHeader from '../documents/DocumentHeader.js';
import i18next from '../../i18n.js';
import MainMenu from '../menu/MainMenu.js';
import DocumentForm from '../documents/DocumentFofm.js';
import { base64toBlob, loadAvatar } from '../helpers/HelperFunctions.js';
import { unknownErrorMessageDialog } from '../ModalDialog.js';
import LeftDaysInfo from './LeftDaysInfo.js';
import { Button } from 'react-bootstrap';
import { checkEmail } from '../helpers/CheckFunctions.js';
import { BackgroundContainer } from '../account/BackgroundContaner.js';
import { getElementByName } from '../documents/DocumentHelpers.js';

const Profile = () => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [formMode, setFormMode] = useState(formModes.read);
    const [userData, setUserData] = useState(null);
    const [cropValue, setCropValue] = useState(null);
    const [changed, setChanged] = useState(false);
    const navigate = useNavigate();
    const canvasRef = useRef(null);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        fetch(`/api/account/GetCurrentUser`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }
                else {
                    unknownErrorMessageDialog(() => { navigate(urls.mainPage) });
                }
            })
            .then((data) => {
                if (data) {
                    initUserData(data);
                    setFormMode(formModes.read);
                    setLoading(false);
                }
            });
    }

    const initUserData = (responseData) => {
        const initData = responseData;
        initData.form = JSON.parse(initData.form);

        if (!initData.properties['carInformationForm']) {
            initData.properties['carInformationForm'] = [{
                type: 'sxu:carInformation',
                properties: {}
            }];
        }
        else {
            initData.properties['hasCar'] = true;
            const carInformation = initData.properties['carInformationForm'];
            if (carInformation[0].properties['sxu:engineType']) {
                carInformation[0].properties[`sxu:fuelType_${carInformation[0].properties['sxu:engineType']}`] = carInformation[0].properties['sxu:fuelType'];
            }
        }

        if (initData.associations.avatar && initData.associations.avatar.length > 0) {
            loadAvatar(initData.properties['cm:userName'], initData.associations.avatar[0].split('/').pop()).then(imgUrl => {
                initData.properties['userImage'] = imgUrl ?? resources.defaulUserImg;
                updateFields(initData);
                setUserData(initData);
            });
        }
        else {
            updateFields(initData);
            setUserData(initData);
        }
    }

    const onCloseHandler = () => {
        navigate(urls.mainPage);
    }

    const submit = () => {
        setSaving(true);
        const formData = new FormData();
        let croppedImage = '';

        if (cropValue) {
            const imgType = 'image/png';
            croppedImage = canvasRef.current.toDataURL(imgType);
            const blob = base64toBlob(croppedImage, imgType);
            formData.append('file', blob, 'avatar.png');
        }
        formData.append('model.Properties', JSON.stringify(configueProps(userData).properties));
        formData.append('model.Type', userData.type);

        fetch('/api/Account/UpdateUserProfile', {
            method: 'POST',
            body: formData,
        })
            .then(async response => {
                if (!response.ok) {
                    console.error('Update user data error with status: ', response.status);
                    unknownErrorMessageDialog();
                }
                loadData();
                setSaving(false);
                setSubmitted(false);
            })
            .catch(error => {
                console.error('Update user data error with status: ', response.status);
                console.error(error);
                loadData();
                unknownErrorMessageDialog();
                setSaving(false);
                setSubmitted(false);
            });
    }

    const onProfileAction = (key) => {
        switch (key) {
            case menuTabKeys.save:
                if (!saving) {
                    if (changed) {
                        if (checkInputPage()) {
                            if (cropValue) {
                                const img = new Image();
                                img.onload = () => {
                                    const ctx = canvasRef.current.getContext('2d');

                                    const size = cropValue.crop.size;

                                    let dx = cropValue.crop.leftOffset * img.width;
                                    if (dx < 0) dx = 0;
                                    if (dx > img.width - size) dx = img.width - size;

                                    let dy = cropValue.crop.topOffset * img.height;
                                    if (dy < 0) dy = 0;
                                    if (dy > img.height - size) dy = img.height - size;

                                    canvasRef.current.width = size;
                                    canvasRef.current.height = size;

                                    ctx.drawImage(img, dx, dy, size, size, 0, 0, size, size);

                                    submit();
                                };
                                img.src = cropValue.image;
                            }
                            else {
                                submit();
                            }
                        }
                        else {
                            setSubmitted(true);
                        }
                    }
                    else {
                        setFormMode(formModes.read);
                    }
                }
                break;
            case menuTabKeys.close:
                loadData();
                break;
        }
    }

    const checkInputPage = () => {
        let result = true;
        let errorElementName = '';

        if (userData.properties["cm:email"] && !checkEmail(userData.properties["cm:email"])) {
            result = false;
            errorElementName = "cm:email";
        }
        if (result && userData.properties["hasCar"]) {
            const carInfo = userData.properties["carInformationForm"][0];
            if (!carInfo.properties["sxu:carBrand"]) {
                result = false;
                errorElementName = "carInformationForm---0---sxu:carBrand";
            }
            if (result && !carInfo.properties["sxu:carNumber"]) {
                result = false;
                errorElementName = "carInformationForm---0---sxu:carNumber";
            }
            if (result && !carInfo.properties["sxu:carReleaseYear"]) {
                result = false;
                errorElementName = "carInformationForm---0---sxu:carReleaseYear";
            }
            if (result && !carInfo.properties["sxu:engineType"]) {
                result = false;
                errorElementName = "carInformationForm---0---sxu:engineType";
            }
            if (result && !carInfo.properties["sxu:engineVolume"]) {
                result = false;
                errorElementName = "carInformationForm---0---sxu:engineVolume";
            }
            if (result && !carInfo.properties["sxu:carColor"]) {
                result = false;
                errorElementName = "carInformationForm---0---sxu:carColor";
            }
        }

        if (errorElementName) {
            const scrollToElement = () => {
                const errorElement = getElementByName(errorElementName);
                if (errorElement) {
                    errorElement.scrollIntoView({ behavior: "smooth" });
                }
                else {
                    setTimeout(scrollToElement, 200);
                }
            }
            setTimeout(scrollToElement, 200);
        }
        return result;
    }

    const inputChangeHandler = (e) => {
        const { name, value, checked } = e.target;
        const newValue = e.target.type === 'checkbox' ? checked : value;
        if (name === 'userImage') {
            setCropValue(newValue);
        }
        else {
            const updatedData = structuredClone(userData);
            updatedData.properties[name] = newValue;
            updateFields(updatedData);
            setUserData(updatedData);
        }
        setChanged(true);
    }

    const updateFields = (userData) => {
        const carSectionField = userData.form.fields.find(f => f.name === 'carSection');
        const carInformationForm = carSectionField.fields.find(f => f.name === 'carInformationForm');
        carInformationForm.visible = userData.properties['hasCar'];
    }

    const configueProps = (userData) => {
        if (!userData.properties['hasCar']) {
            delete userData.properties['carInformationForm'];
            if (userData.associations?.userCarInfo?.length > 0) {
                userData.properties['assoc:sxu:carsInformation_removed'] = userData.associations.userCarInfo.join(',');
            }
        }
        else {
            const carInformation = userData.properties['carInformationForm'];
            if (carInformation?.length > 0) {
                carInformation[0].properties['sxu:fuelType'] = carInformation[0].properties[`sxu:fuelType_${carInformation[0].properties['sxu:engineType']}`];
            }
        }

        return userData;
    }

    return (<BackgroundContainer type={backgroundTypes.general} >
        <div className="main-content">
            <DocumentHeader key="doc-header" title={i18next.t('profile.profileHeader')} type={listTypes.Users} />
            <div className="profile-form">
                <LeftDaysInfo />
                {loading && <Spinner animation="border" variant="primary" />}
                <canvas ref={canvasRef} style={{ display: "none", borderRadius: "50%" }} ></canvas>
                {!loading && userData && <DocumentForm key="user-form" form={userData.form} formMode={formMode} properties={userData.properties} onChange={inputChangeHandler} submitted={submitted} />}
                {formMode === formModes.read && <div className="btn-form-contaner"><Button className='edit-btn' variant='secondary' onClick={() => {
                    setFormMode(formModes.edit)
                }}>{i18next.t('profile.editProfileText')}</Button></div>}
            </div>
            {formMode === formModes.read && <MainMenu key="doc-menu" menuType={menuTypes.close} onTabClick={onCloseHandler} />}
            {formMode === formModes.edit && <MainMenu key="doc-menu" menuType={menuTypes.create} onTabClick={onProfileAction} />}
        </div>
    </BackgroundContainer>);
}

export default Profile;